// extracted by mini-css-extract-plugin
export var container = "PeliLinkki-module--container--FiD-8";
export var icon = "PeliLinkki-module--icon--oInPv";
export var counter = "PeliLinkki-module--counter--CcKXO";